<div class="pt-4 flex flex-col gap-4">
  <h3 class="text-lg font-medium">{{ 'waters.ratings.heading' | translate }}</h3>

  @if (isLoading()) {
    <div class="flex justify-center py-8">
      <mat-spinner diameter="32" />
    </div>
  } @else if (ratings().length === 0) {
    <p class="text-sm text-gray-500 py-4">{{ 'waters.ratings.empty' | translate }}</p>
  } @else {
    <table mat-table [dataSource]="ratings()" class="w-full">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{ 'waters.ratings.field.name' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <ng-container matColumnDef="locale">
        <th mat-header-cell *matHeaderCellDef>{{ 'waters.ratings.field.locale' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.locale ? (row.locale | uppercase) : '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="arrivalDate">
        <th mat-header-cell *matHeaderCellDef>{{ 'waters.ratings.field.arrivalDate' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.arrivalDate ? (row.arrivalDate | date: 'dd-MM-yyyy') : '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>{{ 'waters.ratings.field.type' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.type ? ('waters.ratings.type.' + row.type | translate) : '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="average">
        <th mat-header-cell *matHeaderCellDef>{{ 'waters.ratings.field.average' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ average(row) }}</td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>{{ 'waters.ratings.field.createdAt' | translate }}</th>
        <td mat-cell *matCellDef="let row">{{ row.createdAt | date: 'dd-MM-yyyy' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row" class="text-right">
          <button mat-icon-button (click)="edit(row)" [matTooltip]="'waters.ratings.edit' | translate">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="delete(row)" [matTooltip]="'waters.ratings.delete' | translate">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  }
</div>
